import { render, staticRenderFns } from "./EvergreenIcon.vue?vue&type=template&id=12053116&scoped=true"
import script from "./EvergreenIcon.vue?vue&type=script&lang=js"
export * from "./EvergreenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12053116",
  null
  
)

export default component.exports